export enum RegularPlanAlertVariantEnum {
  REGULAR_FUND_COMMISSIONS_BOTTOM_SHEET = 'REGULAR_FUND_COMMISSIONS_BOTTOM_SHEET',
  REGULAR_FUND_COMMISSIONS_GRAPH_BOTTOM_SHEET = 'REGULAR_FUND_COMMISSIONS_GRAPH_BOTTOM_SHEET',
  REGULAR_FUND_COMMISSIONS_SUMMARY_BOTTOM_SHEET = 'REGULAR_FUND_COMMISSIONS_SUMMARY_BOTTOM_SHEET'
}

export type RegularPlanAlertVariant = `${RegularPlanAlertVariantEnum}`

export interface FundInfo {
  name: string
  category: string
  nature?: string
  logoUrl?: string
  isin?: string
}

export interface SingleFundCommissionsData {
  commissionAmount: number
  fund: FundInfo
}

export interface SingleFundGraphData {
  commissionAmount: number
  regularReturns: number
  directReturns: number
  fund: FundInfo
}

export interface PortfolioAlertData {
  totalCommissionsPaid: number
  totalRegularFunds: number
}

export interface RegularPlanAlertSheetResponse {
  fundName: string
  fundNature: string
  fundCategory: string
  commissions: number
  regularReturns: number
  directReturns: number
  totalRegularFundCount: number
  logoUrl: string
  cta: string
}
